<!--
 * @Author: p_fy
 * @Date: 2019-07-17 13:47:49
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 14:52:16
 * @Description: 石化云仓-普仓供给列表以及详情信息。
 -->
<template>
  <div ref="el" v-loading="viewControl.loading" class="supply-items-container">
    <template v-if="!viewControl.loading && data.length < 1">
      <div class="supply-item-container no-data-info">
        <font>暂无匹配数据</font>
      </div>
    </template>
    <template v-for="(supply, index) of data">
      <div :key="index" class="supply-item-container">
        <div class="supply-item-card">
          <div v-viewer class="supply-item-picture">
            <template v-if="storageUrl(supply)[0]">
              <el-image :src="storageUrl(supply)[0] | getImg" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
            </template>
            <template v-else>
              <el-image :src="require('@/assets/img/default_img.png')" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
            </template>
          </div>
          <div class="supply-item-content">
            <div class="content-left">
              <div class="title">
                <span class="supply-supplyName">
                  {{ supply.supplyName }}
                </span>
                <el-tag type="danger">普通仓库</el-tag>
              </div>
              <div>
                <span>仓库位置：</span>
                <span>{{ supply.storageLocationLabel + supply.detailedLocation }}</span>
              </div>
              <div>
                <span>仓库条件：</span>
                <span>普通</span>
                <el-divider direction="vertical" />
                <span>可租用面积：{{ supply.rentableArea }}m²</span>
                <el-divider direction="vertical" />
                <span>货物类型：{{ supply.storageTypeLabel }}</span>
              </div>
              <div>
                <span>公司名称：</span>
                <span>{{ supply.companyName }}</span>
                <el-divider direction="vertical" />
                <span>联系人：{{ supply.linkMan }}</span>
              </div>
              <div class="remarksCls">
                <span>备注说明：</span>
                <span :title="supply.storageRecommend">{{ supply.storageRecommend }}</span>
              </div>
            </div>
            <div class="content-middle">
              <div>期望租金</div>
              <div class="one">
                <strong>¥{{ supply.expectPrice }}元/m²/天</strong>
              </div>
              <div class="two">起租日期</div>
              <div class="there">{{ supply.leaseTime }}</div>
            </div>
            <div class="content-right">
              <div class="one">{{ supply.createDate }}</div>
              <div class="two" @click="collect(supply)">
                <i
                  :class="[{iconshoucang:supply.collectionStatus != '1'},{iconshoucang1:supply.collectionStatus == '1'}]"
                  class="iconfont"
                />
                <div>{{ supply.collectionStatus == '1' ?'已收藏':'未收藏' }}</div>
              </div>
              <template v-if="authStatus == '2'">
                <el-button v-if="supply.publishStatus == '3'" v-permission="['4-1','4-2']" style="color: #be2316 !important;" type="text">已成交</el-button>
                <el-button v-else v-permission="['4-1','4-2']" style="background-color: #409eff;color: white;border-color: #409eff;" size="mini" @click="deal(supply)">成交</el-button>
                <el-button v-if="supply.appointmentStatus == '0' " v-permission="['4-1','4-2']" size="mini" @click="offer(supply)">预约看仓</el-button>
                <el-button v-else v-permission="['4-1','4-2']" style="background-color: #e6a23c;color: #ecf5ff;border-color: #e6a23c;" size="mini">已预约</el-button>
              </template>
              <el-button plain size="mini" @click="details(supply)">
                详情
                <i :class="{'expand': !supply.hidden}" class="el-icon-d-arrow-right" />
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="!supply.hidden" class="supply-item-details">
          <div class="base-info">
            <div>基本信息</div>
            <div class="info-detail">
              <div class="detail-item">
                <div :title="supply.storageLocationLabel"><span>仓库位置</span> {{ supply.storageLocationLabel }}</div>
                <div :title="supply.detailedLocation"><span>详细地址</span> {{ supply.detailedLocation }}</div>
                <div :title="`${supply.floorWeight}吨`"><span>地坪承重</span> {{ supply.floorWeight }}吨</div>
                <div :title="supply.warehouseTypeLabel"><span>仓库类型</span> {{ supply.warehouseTypeLabel }}</div>
              </div>
              <div class="detail-item">
                <div :title="supply.storeEquipmentLabel"><span>库内设备</span> {{ supply.storeEquipmentLabel }}</div>
                <div :title="supply.storageTypeLabel"><span>货物类型</span> {{ supply.storageTypeLabel }}</div>
                <div :title="`${supply.expectPrice}元/m²/天`"><span>租金</span> {{ supply.expectPrice }}元/m²/天</div>
                <div :title="supply.leaseTermLabel"><span>起租年限</span> {{ supply.leaseTermLabel }}</div>
              </div>
              <div class="detail-item">
                <div :title="supply.companyName"><span>公司名称</span> {{ supply.companyName }}</div>
                <div :title="supply.leaseTime"><span>起租日期</span> {{ supply.leaseTime }}</div>
                <div :title="`${supply.lettableArea}m²`"><span>起租面积</span> {{ supply.lettableArea }}m²</div>
                <div :title="`${supply.rentableArea}m²`"><span>可租用面积</span> {{ supply.rentableArea }}m²</div>
              </div>
              <div class="detail-item">
                <div :title="`${supply.coveredArea}m²`"><span>建筑面积</span> {{ supply.coveredArea }}m²</div>
                <div :title="supply.fireQualificationLabel"><span>消防资质</span> {{ supply.fireQualificationLabel }}</div>
                <div :title="supply.landingPlatformLabel"><span>卸货平台</span> {{ supply.landingPlatformLabel }}</div>
                <div :title="supply.floorTextureLabel"><span>地坪质地</span> {{ supply.floorTextureLabel }}</div>
              </div>
              <div class="detail-item" />
            </div>
          </div>
          <div class="contact-info">
            <div>联系人信息</div>
            <ul>
              <li>
                <span>联系人</span> {{ supply.linkMan }}
              </li>
              <li>
                <span>联系电话</span> {{ supply.telephone }}
              </li>
            </ul>
          </div>
          <div class="imgs-info">
            <div>库房照片</div>
            <ul v-if="storageUrl(supply)" v-viewer>
              <li v-for="(item , ids) in storageUrl(supply)" :key="ids">
                <el-image class="infoImg" :src="item | getImg" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
              </li>
            </ul>
            <ul v-else v-viewer>
              <li>
                <el-image class="infoImg" :src="require('@/assets/img/default_img.png')" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
              </li>
            </ul>
            <div>备注</div>
            <span>{{ supply.storageRecommend }}</span>
          </div>
        </div>
      </div>
    </template>
    <div class="supply-items-pagination">
      <el-pagination
        :current-page="pagination.pageNo"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper,total, sizes"
        @current-change="changeCurrent"
        @size-change="changeSize"
      />
    </div>
  </div>
</template>

<script>
import { findPageSupply } from '@/api/cloud/storage-supply-info/components/storageSupplyItems'
import { tableClass } from '@/api/cloud/storage-supply-info/components/StorageSupplyItemsParam' // 仓储供给信息、表单参数列表
import { mapGetters } from 'vuex'
const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)

export default {
  name: 'StorageSupplyItems',
  filters: {
    textFormat(date) {
      console.log(date)
    }
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      data: [],
      viewControl: {
        loading: false
      },
      pagination: table.Page
    }
  },
  computed: {
    storageUrl(supply) { // 图片回调
      return (supply) => {
        if (supply.storageUrl == null || supply.storageUrl == '') {
          return false
        }
        return supply.storageUrl.split(',').filter(n => n) // 数组去空
      }
    },
    ...mapGetters(['userType', 'userInfo', 'authStatus'])
  },
  watch: {
    params: {
      immediate: true, // 在监听开始后立即回调
      handler(val) {
        this.loadData()
      },
      deep: true
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 数字转为货币
    getMoney(num) {
      return Number(200).toLocaleString(undefined, {
        style: 'currency',
        currency: 'CNY'
      })
    },
    // 预约看仓
    offer(supply) {
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      if (this.userInfo.isAdmin == '0') {
        this.$router.push({ name: 'QualificationsAuthen' })
        return
      }
      this.$emit('order', supply)
    },
    // 收藏
    collect(supply) {
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      if (this.authStatus != '2') {
        this.$message({
          offset: 100,
          message: '该用户还未资质认证，请先资质认证',
          type: 'warning'
        })
        setTimeout(() => {
          this.$router.push({ name: 'QualificationsAuthen' })
        }, 200)
        return
      }
      this.$emit('favorites', supply)
    },
    // 详情
    details(supply) {
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      if (supply.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 成交
    deal(item) {
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      this.$emit('deal', item)
    },
    loadData() {
      this.viewControl.loading = true
      this.params.publishStatus = '2'
      this.params.myType = false // 根据发布状态查询
      console.log('this.params', this.params)
      findPageSupply(Object.assign(this.pagination, this.params), this.userType).then(res => {
        this.data = res.result.rows.map(res => {
          res.hidden = true
          res.collectionSubmit = false
          return res
        })
        this.pagination.total = res.result.total
        this.viewControl.loading = false
      }).catch(err => {
        console.log(err)
        this.viewControl.loading = false
      })
    },
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    }
  }
}
</script>
<style lang="scss" scoped>
$perfix: "supply-item";
$main-color: rgb(190, 35, 22);

/deep/.no-data-info {
    background-color: #fff;
    width: 100%;
    text-align: center;
    margin-top: 8px;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
  }

.#{$perfix}-container {
  *::selection {
    background-color: rgba(0,0,0,0) !important;
  }

  width: 100%;
  box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.09);
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  border-radius:4px;
  .supply-supplyName{
    color: #be2316;
    font-weight: 600;
  }
  .#{$perfix}-card {
    display: flex;
    padding: 12px;
    border-radius: 4px;
    padding: 12px;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    align-items: center;
    border: 1px solid #ebeef5;
    .#{$perfix}-picture {
      // width: 225px;
      height: 168px;
      // height: 100%;
      display: inline-block;
      >img{
        width: 100%;
        height: 100%;
      }
      &.hidden {
        display: none;
      }
      .el-image {
        height: 168px;
        width: 225px;
        .image-slot {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 14px;
          [class*=" el-icon-"],
          [class^="el-icon-"] {
            font-family: element-icons !important;
            speak: none;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            vertical-align: baseline;
            display: inline-block;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-size: 30px;
          }
        }
      }
    }

    .#{$perfix}-content {
      display: flex;
      padding-left: 24px;
      height: 171px;
      width: 100%;
      justify-content: space-between;
      >div{
        height: 100%;
      }
      .content-left {
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .remarksCls{
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          overflow: hidden;
          // text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          // word-wrap: break-word;
          word-break: break-all;
        }
        span:first-child::after {
          // content: " : ";
        }
        .title {
          color: $main-color;
          font-weight: bold;
          white-space: nowrap;
          height: 24px;
          font-size: 24px;
          margin-bottom: 9px;
          width: 100%;
          i {
            color: initial !important;
            font-weight: initial !important;
            font-size: 1px !important;
            margin: 0 0;
            padding: 0 0;
            width: 24px;
          }
        }
      }
      .content-middle {
        text-align: center;
        font-size: 14px;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        >* {
          height: 28px;
          &:nth-child(even) {
            margin-bottom: 17px;
          }
          &:first-child {
            margin-top: 10px;
          }
        }
        > div {
          padding: 4px 0px;
          width: 100%;
          &:nth-child(odd) {
            color: #ccc;
          }
        }

        .one {
          color: $main-color;
          strong {
            font-size: 24px;
          }
        }

        .there {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .content-right {
        width: 15%;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-direction: column;
        >*{
          // height: 28px;
          // margin-bottom: 15px;
         &:first-child {
            margin-top: 10px;
           }
        }
        > div {
          padding: 4px 0px;
        }

        .two {
          display: flex;
          width: 4rem;
          text-align: center;
          cursor: pointer;
          i {
            color: #be2316;
          }
        }
        /deep/ .el-button {
          background-color: #be2316;
          color: white;
          border-color: #be2316;
        }

        /deep/ .el-button.is-plain {
          background-color: white;
          color: #be2316;
          border-color: #be2316;
          padding: 7px 4px !important;
          width: 56px;
          span > i {
            transition: 1s all;
            transform: rotateZ(90deg);
            &.expand {
              transform: rotateZ(-90deg);
            }
          }
        }
      }
    }
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        span:after {
          content: " : ";
        }
        .info-detail{
          display: flex;
          flex-direction: column;
          color: #000000;
          font-weight: normal;
          margin-bottom: 0;
          .detail-item{
            display: flex;
            margin-bottom: 24px;
            div{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 10px;
              &:nth-child(1){
                width: 30%;
              }
              &:nth-child(2){
                width: 30%;
              }
              &:nth-child(3){
                width: 20%;
              }
              &:nth-child(4){
                width: 20%;
              }
            }
          }
        }
      }
      &.contact-info {
        ul {
          width: 50%;
          columns: 2;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 4px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      &.imgs-info {
        // word-wrap: break-word;
        word-break: break-all;
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            .infoImg {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
}

.supply-items-pagination{
  width: 100%;
  margin-top: 24px;
}
  .el-button--mini{
    width: 80px!important;
  }
</style>

